<template>
  <div class="class-column kakaExposure" :data-exposure-categoryid="column.categoryId" :data-exposure-location="kklocation" data-type="category">
    <el-skeleton :loading="loading" animated>
      <template slot="template">
        <el-skeleton-item variant="h3" style="width: 30%;" />
        <div class="column-list f--c">
          <el-skeleton-item
            v-for="i in 3"
            :key="i"
            variant="image"
            style="width: 200px;height: 230px; margin-right: 10px"
          />
        </div>
      </template>
      <div>
        <div class="title f-b-c">
          <div>{{ column.name }}</div>
          <div class="pointer f-c right" @click="jump()">
            {{$t('indexPage.viewMore')}}
            <!-- <i class="iconfont icon-Frame_2" style="margin-left:10px"></i> -->
          </div>
        </div>

        <div class="column-list f--c">
          <!-- 专辑 -->
          <!-- <div v-for="(item ,i) in column.productsList" :key="i" class="img pointer" @click="jumpProductDetail(item)">
            <oss-img :src="item.imgUrl" :width="200" :height="250" />
          </div> -->
          <div v-for="(item ,i) in column.productCategoryList" :key="i" class="img pointer" @click="jumpProductDetail(item)">
            <oss-img :src="item.images" :width="200" :height="250" />
          </div>
        </div>
      </div>
    </el-skeleton>
  </div>
</template>

<script>
import OssImg from '../../../components/OssImg.vue'
export default {
  components: { OssImg },
  props: {
    column: {
      type: Object,
      default: () => {}
    },
    kklocation: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  computed: {
    loading() {
      return !this.column.name
    }
  },
  methods: {
    jump() {
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_classify_click`,
        value: JSON.stringify({ categoryId: this.column.categoryId })
      })
      // this.$router.push({ path: '/product-list', query: { categoryId: this.column.categoryId }})
      location.href = `/product-list/${this.column.categoryUrl}`
    },
    jumpProductDetail(item) {
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_classifyProduct_click`,
        value: JSON.stringify({ kkProductId: item.kkProductId })
      })
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_classify_click`,
        value: JSON.stringify({ categoryId: this.column.categoryId })
      })
      // let path = `/commodity/product-detail?id=${item.kkProductId}`
      // if (item.color) path += `&color=${item.color}`
      // window.open(path)
      this.jumpDetailSeo(item.kkProductId, item.color)
    }
  }
}
</script>

<style lang="scss" scoped>
.class-column{
	background-color: #fff;
	border-radius: 4px;
	padding: 16px;

  /deep/ .title {
    font-weight: 600;
    font-size: 18px;
    color: #303133;
    .right{
      font-size: 14px;
      font-weight: 400;
      color: #909399;
    }
    .right:hover {
      color: #9AC331;
    }
  }

  .class-column >div:last-child {
    margin-right: auto;
  }
	/deep/ .column-list {
		// height: 250px;
		margin-top: 14px;
    justify-content: space-between;

		.img {
			width: 32%;
      height: 0;
      border-radius: 4px;
      margin-right: 2%;
      position: relative;
      padding-bottom: 44%;

			img {
        display: block;
				object-fit: cover;
        border-radius: 4px;
        width: 100%;
        height: 100%;
        position: absolute;
			}
		}
    .img:nth-child(3) {
      margin-right: 0;
    }
	}

}
</style>
